import { setupListeners } from '@reduxjs/toolkit/query'
import { configureStore } from '@reduxjs/toolkit'
import apiSlice from './api/apiSlice';
import trainingFilterReducer from './reducers/training'
import galleryReducer from "./reducers/gallery";
import imageViewReducer from "./reducers/imageView";
import eventReducer from "./reducers/events";
import workspaceReducer from "./reducers/workspace";
import modalReducer from './reducers/modal';
import aboutReducer from './reducers/about';


const store = configureStore({
    reducer: {
        galleryFilter: galleryReducer,
        trainingFilter: trainingFilterReducer,
        imageView: imageViewReducer,
        modal: modalReducer,
        eventFilter: eventReducer,
        workspaceFilter: workspaceReducer,
        about: aboutReducer,
        [apiSlice.reducerPath]: apiSlice.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware)
})


export default store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch


setupListeners(store.dispatch);